import {
    TOGGLE_LOADING_INDICATOR,
    SET_MESSAGE_RESPONSE,MessageResponse,
    SET_MY_USER
} from "./types";

export function toggleLoadingIndicator(showLoading: boolean) {
    return {
        type: TOGGLE_LOADING_INDICATOR,
        payload: showLoading
    };
}

export function setMessageResponse(messageResponse: MessageResponse | null) {
    return {
        type: SET_MESSAGE_RESPONSE,
        payload: messageResponse
    };
}

export function toggleShowMyUser(showMyUser: boolean) {
    return {
        type: SET_MY_USER,
        payload: showMyUser
    };
}